<template>
  <b-card no-body class="cursor-pointer" :class="{active: visible}">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <div
        aria-controls="accordion"
        @click="visible = !visible"
        class="faqs-tab text-left d-flex justify-content-between align-items-center"
      >
        <span>{{ title }}</span
        ><b-icon
          icon="caret-down-fill"
          font-scale="0.8"
          :rotate="visible ? 180 : 0"
        ></b-icon>
      </div>
    </b-card-header>
    <b-collapse v-model="visible" id="accordion">
      <b-card-body class="px-6 py-5">
        <template v-for="(content, index) in contents">
          <b-card-text :key="index">{{ content }}</b-card-text>
        </template>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'Collapse',
  props: {
    title: {
      type: String,
      default: '',
    },
    contents: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="scss">
.card {
  border-radius: 8px;
  border: 1px solid #ebebeb;
  background: $white;
  &:not(:last-of-type) {
    margin-bottom: 24px;
  }
  .card-header {
    border-radius: 8px;
    background: transparent;
    .faqs-tab {
      background: transparent;
      border-radius: 8px;
      border: none;
      box-shadow: none;
      padding: 12px 16px;
      color: $gray-700;
    }
  }
  &.active {
    border: 1px solid $primary;
    .card-header {
      background: $primary;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
    .faqs-tab {
      color: $white;
      .b-icon {
        color: white;
      }
    }
    .card-text {
      margin: 0;
      min-height: 24px;
    }
  }
}
</style>
